// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2byfQ","fullView":"styles_fullView__2FFYR"};